import { render, staticRenderFns } from "./WowzaListView.vue?vue&type=template&id=122d97aa&scoped=true"
import script from "./WowzaListView.vue?vue&type=script&lang=js"
export * from "./WowzaListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122d97aa",
  null
  
)

export default component.exports